import { render, staticRenderFns } from "./airSamplesTable.vue?vue&type=template&id=67548003"
import script from "./airSamplesTable.vue?vue&type=script&lang=js"
export * from "./airSamplesTable.vue?vue&type=script&lang=js"
import style0 from "./airSamplesTable.vue?vue&type=style&index=0&id=67548003&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports